// extracted by mini-css-extract-plugin
module.exports = {"spinner_ta":"spinner_ta","taker-assist":"taker-assist","container_ta":"container_ta","spinner-icon_ta":"spinner-icon_ta","spinner":"spinner"};